/**
 * Single-select User Type. Other filter selects stay multi-select checkboxes.
 */
const UserTypePinnedField = ({ field, value, onChange, loading, isLoading }) => {
  const options = field.options || [];
  const selected = Array.isArray(value) ? value[0] || '' : value || '';

  return (
    <label className="block">
      <span className="block text-sm font-medium mb-1" style={{ color: 'var(--color-text)' }}>
        {field.label || 'User Type'}
      </span>
      <select
        name={field.name}
        value={selected}
        onChange={onChange}
        disabled={loading || isLoading}
        aria-label={field.label || 'User Type'}
        className="px-3 py-2 border rounded disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs"
      >
        <option value="">All students</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label || option.value}
          </option>
        ))}
      </select>
    </label>
  );
};

export default UserTypePinnedField;
